document.addEventListener("DOMContentLoaded", (event) => {
  showImageOnHover();
});

function showImageOnHover() {
  let parentContainer = document.querySelector(".tiles-listing-wrap"); // Replace with your parent container
  let parentContainerRelated = document.querySelector(
    ".related-postlistings-itemswrap"
  );
  if (parentContainer) {
    parentContainer.addEventListener("mouseover", function (event) {
      const tileListing = event.target.closest(".tile-listing--image");
      if (!tileListing) return;

      const mainImage = tileListing.querySelector(".tiles-main-img");
      const productImages = tileListing.querySelectorAll(
        ".products-in-use-images"
      );
      let currentImageIndex = 0;
      let intervalId;

      if (productImages.length > 0) {
        mainImage.dataset.originalSrc = mainImage.src;
        mainImage.src = productImages[0].src;
        mainImage.srcset = productImages[0].src;

        intervalId = setInterval(() => {
          currentImageIndex = (currentImageIndex + 1) % productImages.length;
          mainImage.src = productImages[currentImageIndex].src;
          mainImage.srcset = productImages[currentImageIndex].src;
        }, 1200);

        tileListing.dataset.intervalId = intervalId;
      }
    });

    parentContainer.addEventListener("mouseout", function (event) {
      const tileListing = event.target.closest(".tile-listing--image");
      if (tileListing) {
        const productImages = tileListing.querySelectorAll(
          ".products-in-use-images"
        );

        if (!tileListing) return;

        const mainImage = tileListing.querySelector(".tiles-main-img");
        if (productImages.length > 0) {
          clearInterval(tileListing.dataset.intervalId);
          mainImage.src = mainImage.dataset.originalSrc;
          mainImage.srcset = mainImage.src;
        }
      }
    });
  } else if (parentContainerRelated) {
    parentContainerRelated.addEventListener("mouseover", function (event) {
      const tileListingrelated = event.target.closest(".tile-listing--image");
      if (!tileListingrelated) return;

      const mainImage = tileListingrelated.querySelector(".tiles-main-img");
      var productImages = "";
      var productImages = tileListingrelated.querySelectorAll(
        ".products-in-use-images"
      );
      let currentImageIndex = 0;
      let intervalId;

      if (productImages.length > 0) {
        mainImage.dataset.originalSrc = mainImage.src;
        mainImage.src = productImages[0].src;
        mainImage.srcset = productImages[0].src;

        intervalId = setInterval(() => {
          currentImageIndex = (currentImageIndex + 1) % productImages.length;
          mainImage.src = productImages[currentImageIndex].src;
          mainImage.srcset = productImages[currentImageIndex].src;
        }, 1200);

        tileListingrelated.dataset.intervalId = intervalId;
      }
    });

    parentContainerRelated.addEventListener("mouseout", function (event) {
      const tileListingrelated = event.target.closest(".tile-listing--image");
      var productImages = "";
      if (tileListingrelated) {
        var productImages = tileListingrelated.querySelectorAll(
          ".products-in-use-images"
        );
      if (!tileListingrelated) return;

      const mainImage = tileListingrelated.querySelector(".tiles-main-img");
      if (productImages.length > 0) {
        clearInterval(tileListingrelated.dataset.intervalId);
        mainImage.src = mainImage.dataset.originalSrc;
        mainImage.srcset = mainImage.src;
      }
    }
    });
  }
}
